import { sessionColor } from '../../../core/constants/transfers';

// Leyenda compacta: color → sesión TE. Usa el MISMO índice que buildTransferredRows
// (color por posición en transfer_sessions) para que los colores coincidan con el
// subrayado de las filas. Lo importante es CLIENTE · FINCA; el endpoint derivado
// (transfer_sessions[]) hoy NO los trae (solo code/date) → se leen forward-compatible
// (s.client/s.farm) y, mientras tanto, cae al código de la sesión.
function sessionLabel(s) {
    const parts = [s.client?.name, s.farm?.name].filter(Boolean);
    return parts.length ? parts.join(' · ') : s.code;
}

export default function SessionLegend({ sessions, excludeId }) {
    const items = (sessions || [])
        .map((s, i) => ({ ...s, color: sessionColor(i) })) // color por índice original (coincide con el tablero)
        .filter((s) => (s.transfers?.length || 0) > 0 && s.id !== excludeId);

    if (!items.length) return null;

    return (
        <div className="transfer-legend" aria-label="Leyenda de sesiones">
            <span className="transfer-legend__label">Sesiones</span>
            {items.map((s) => (
                <span key={s.id} className="transfer-legend__chip" title={s.code}>
                    <span className="transfer-legend__dot" style={{ background: s.color }} />
                    <span className="transfer-legend__code">{sessionLabel(s)}</span>
                    <span className="transfer-legend__meta">· {s.transfers.length}</span>
                </span>
            ))}
        </div>
    );
}
